export enum SessionTypeEnum {
  Explorer = 'Explorer',
  Editor = 'Editor'
}
